import { Mixpanel } from "../../mixpanel";
import { getConcatenatedStringOfFeaturesForAnalytics } from "../../abTesting";
import useCampaign from "./useCampaign";
import useUTMParams from "./useUTMParams";

/**
 * Builds the Calendly `utm` prop.
 *
 * Real UTM params from the landing URL ride Calendly's utm fields as-is.
 * Everything else — source attribution (sourceType/sourceValue/campaignName),
 * the Mixpanel id, AB-test assignments, click ids and page context — is packed
 * as JSON into salesforce_uuid, and parsed back by the calendly webhook
 * (backend/apps/better/src/utils/calendly-utils.js).
 */
const useCalendlyTracking = (props) => {
  const { handleEvent, getCampaignValue, getSourceType, campaignName } =
    useCampaign(props);
  const { utmParams, clickIds, ipAddress, originalUrl } = useUTMParams();

  const extraData = {
    protocolVersion: 2,
    sourceType: getSourceType(),
    sourceValue: getCampaignValue(),
    campaignName,
    mixpanelId: Mixpanel.getId(),
    abTests: getConcatenatedStringOfFeaturesForAnalytics([
      "landingPageVersion",
      "mainHomeImage",
    ]),
    utmId: utmParams.utm_id,
    fbclid: clickIds.fbclid,
    gclid: clickIds.gclid,
    fbc: clickIds.fbc,
    ipAddress,
    originalUrl,
  };

  const utm = {
    utmSource: utmParams.utm_source,
    utmMedium: utmParams.utm_medium,
    utmCampaign: utmParams.utm_campaign,
    utmTerm: utmParams.utm_term,
    utmContent: utmParams.utm_content,
    salesforce_uuid: JSON.stringify(extraData),
  };

  return { utm, handleEvent };
};

export default useCalendlyTracking;
